// src/components/Fallback.tsx

import PageWrapper from '../PageWrapper'
import './loader.css'
import { useEffect } from 'react'

// ref: https://projects.lukehaas.me/css-loaders/

function Fallback() {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
  }, [])

  return (
    <PageWrapper
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
      }}
    >
      <div className="loader"></div>
    </PageWrapper>
  )
}

export default Fallback
